import glamorous from "glamorous";

import PlaceholderIcon from "../../assets/icons/Placeholder.svg";
import OmniboxIcon from "../../assets/icons/Omnibox.svg";
import TimelineIcon from "../../assets/icons/Timeline.svg";
import AutoCirculationIcon from "../../assets/icons/AutoCirculation.svg";
import UserPortalIcon from "../../assets/icons/UserPortal.svg";
import ServiceHoursIcon from "../../assets/icons/ServiceHours.svg";
import MetaFieldsIcon from "../../assets/icons/MetaFields.svg";
import SingleSignOnIcon from "../../assets/icons/SingleSignOn.svg";
import ActiveDirectoryIcon from "../../assets/icons/ActiveDirectory.svg";
import CloudIcon from "../../assets/icons/Cloud.svg";

import FullControlIcon from "../../assets/icons/FullControl.svg";
import BatteriesIncludedIcon from "../../assets/icons/BatteriesIncluded.svg";
import CustomAdditionsIcon from "../../assets/icons/CustomAdditions.svg";
import ImportExportIcon from "../../assets/icons/ImportExport.svg";
import OnDemandSupportIcon from "../../assets/icons/OnDemandSupport.svg";
import UnlimitedDepartmentsIcon from "../../assets/icons/UnlimitedDepartments.svg";

import MessengerIcon from "../../assets/icons/Messenger.svg";
import HamburgerMenuIcon from "../../assets/icons/HamburgerMenu.svg";
import LoginIcon from "../../assets/icons/Login.svg";
import CloseIcon from "../../assets/icons/Close.svg";

import AccountIcon from "../../assets/icons/Account.svg";
import EquipmentIcon from "../../assets/icons/Equipment.svg";
import DateRangeIcon from "../../assets/icons/DateRange.svg";
import CheckMarkIcon from "../../assets/icons/CheckMark.svg";

const defaultTimelineStyle = {
  height: 75,
  width: 75
};

const handleColors = ({ theme, glam = {} }) => ({
  ...defaultTimelineStyle,
  "> *:not([fill='none'])": {
    fill: glam.color || theme.main.colors[`vibrant${[1,2,3,4,5][Math.round(Math.random() * 4)]}`]
  }
});

const messengerIconStyle = {
  height: 25,
  marginRight: "0.25rem",
  verticalAlign: "middle",
  width: 25,
  "> path:not([fill='none'])": {
    fill: "#fff"
  }
};

const menuIconStyle = ({ size = 40, color, theme }) => ({
  height: size,
  width: size,
  "> path:not([fill='none'])": {
    fill: color || theme.main.colors.ocean
  }
});

export const Placeholder = glamorous(PlaceholderIcon)(handleColors);
export const Omnibox = glamorous(OmniboxIcon)(handleColors);
export const Timeline = glamorous(TimelineIcon)(handleColors);
export const AutoCirculation = glamorous(AutoCirculationIcon)(handleColors);
export const UserPortal = glamorous(UserPortalIcon)(handleColors);
export const ServiceHours = glamorous(ServiceHoursIcon)(handleColors);
export const MetaFields = glamorous(MetaFieldsIcon)(handleColors);
export const SingleSignOn = glamorous(SingleSignOnIcon)(handleColors);
export const ActiveDirectory = glamorous(ActiveDirectoryIcon)(handleColors);
export const Cloud = glamorous(CloudIcon)(handleColors);

export const FullControl = glamorous(FullControlIcon)(handleColors);
export const BatteriesIncluded = glamorous(BatteriesIncludedIcon)(handleColors);
export const CustomAdditions = glamorous(CustomAdditionsIcon)(handleColors);
export const ImportExport = glamorous(ImportExportIcon)(handleColors);
export const OnDemandSupport = glamorous(OnDemandSupportIcon)(handleColors);
export const UnlimitedDepartments = glamorous(UnlimitedDepartmentsIcon)(handleColors);

export const Messenger = glamorous(MessengerIcon)(messengerIconStyle);
export const HamburgerMenu = glamorous(HamburgerMenuIcon)(menuIconStyle);
export const Login = glamorous(LoginIcon)(menuIconStyle);
export const Close = glamorous(CloseIcon)(menuIconStyle);

export const Account = glamorous(AccountIcon)(menuIconStyle);
export const Equipment = glamorous(EquipmentIcon)(menuIconStyle);
export const DateRange = glamorous(DateRangeIcon)(menuIconStyle);
export const CheckMark = glamorous(CheckMarkIcon)(menuIconStyle);



// WEBPACK FOOTER //
// ./src/components/FeatureIcons/index.js